"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("./core");
__export(require("./formatters"));
__export(require("./core"));
exports.default = core_1.default;



//////////////////
// WEBPACK FOOTER
// ./~/intl-messageformat/dist/index.js
// module id = 402
// module chunks = 0